import React from 'react'
import { AuthProvider } from '@maui-mf/common-react'
import { MauiMfSplitFactory } from '@maui-mf/root/splitio-react'
import { Header } from './components/Header'

export default function Root() {
  return (
    <AuthProvider>
      <MauiMfSplitFactory>
        <Header />
      </MauiMfSplitFactory>
    </AuthProvider>
  )
}
